module.exports = __webpack_public_path__ + "media/images/about_800x600-9d985485bb8d9db2a8978846302ce58b.jpg";